module.exports = __webpack_public_path__ + "static/media/dice-four.15df5dc7.svg";